/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.set.deleteValues'

export { $nsid }

/** Delete values from a specific set. Attempting to delete values that are not in the set will not result in an error */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    name: l.string(),
    values: l.array(l.string(), { minLength: 1 }),
  }),
  l.payload(),
  ['SetNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
